/* ========================================================================== *\
___________       __         .__
\_   _____/ _____/  |________|__| ____
 |    __)_ /    \   __\_  __ \  |/  _ \
 |        \   |  \  |  |  | \/  (  <_> )
/_______  /___|  /__|  |__|  |__|\____/
        \/     \/
\* ========================================================================== */
import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';

function RetryImageJobDialog({ row, types, usage, busy, allowed, onClose, onConfirm }) {
  const type = types.find((item) => item.id === row?.job_type);
  const known = type?.credits != null && Number.isFinite(Number(type.credits));
  const cost = known ? Number(type.credits) : null;
  return (
    <Dialog
      open={Boolean(row)}
      onClose={busy ? undefined : onClose}
      maxWidth='sm'
      fullWidth
      aria-labelledby='retry-image-title'
    >
      <DialogTitle id='retry-image-title'>ทำงานนี้ใหม่?</DialogTitle>
      <DialogContent>
        <MDTypography variant='body2'>
          งาน #{row?.id} · {row?.sku || `สินค้า #${row?.product_id}`} ·{' '}
          {type?.name || 'ไม่พบชนิดงาน'}
        </MDTypography>
        <MDTypography variant='body2' fontWeight='bold'>
          {cost === 0 && row?.job_type === 'SKU_STAMP'
            ? 'ฟรี'
            : known
            ? `ประมาณ ${cost} เครดิต`
            : 'ยังไม่มีราคาประมาณ โหลดหน้าใหม่แล้วลองอีกครั้ง'}
        </MDTypography>
        <MDTypography variant='caption' display='block'>
          ใช้รูปและการตั้งค่าเดิม งานจะกลับเข้าคิว
        </MDTypography>
      </DialogContent>
      <DialogActions>
        <MDButton variant='outlined' color='secondary' onClick={onClose} disabled={busy}>
          ยกเลิก
        </MDButton>
        <MDButton
          variant='gradient'
          color='dark'
          onClick={() => onConfirm(row)}
          disabled={busy || !allowed || !known}
        >
          {busy ? 'กำลังส่ง…' : `ยืนยันทำใหม่ · ≈ ${cost ?? '?'} เครดิต`}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
RetryImageJobDialog.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    job_type: PropTypes.string,
    sku: PropTypes.string,
    product_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    credits_used: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  types: PropTypes.arrayOf(PropTypes.object).isRequired,
  usage: PropTypes.shape({
    month_credits: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    month_images: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    quota: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    my_images: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  busy: PropTypes.bool.isRequired,
  allowed: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};
RetryImageJobDialog.defaultProps = { row: null, usage: null };
export default RetryImageJobDialog;
